/* global JSX */
// PanelTitle
// ***********************************************************************************************************************
import * as React from "react";

export interface IPanelTitleProp {
    title: string | JSX.Element;
    classes?: string;
    titleSuffix?: JSX.Element;
    onClick?: () => void;
}

export class PanelTitle extends React.Component<IPanelTitleProp, {}> {
    render() {
        const props = this.props;
        return (
            <div className={"panel-title" + (props.classes ? " " + props.classes : "")} onClick={props.onClick}>
                <span className="text">
                    {props.title}
                </span>
                {props.titleSuffix}
            </div>
        );
    }
}